(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('OrderAttach', OrderAttach);

    OrderAttach.$inject = ['$resource'];

    function OrderAttach ($resource) {
        var resourceUrl =  '/api/customer-orders/:id/attachments';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
